// src/pages/BuyPolicy.js
import React, { useEffect, useRef, useState } from "react";
import SectionHeader from "../components/ui/sectionHeader/SectionHeader";
import TextInput from "../components/ui/input/TextInput";
import TabComp from "../components/ui/tabcomp/TabComp";
import FileUpload from "../components/ui/draganddrop/FileUpload";
import PlanButton from "../components/ui/planbutton/PlanButton";
import PrimaryButton from "../components/ui/button/PrimaryButton";
import "../components/ui/input/textInputStyle.scss";
import SectionSubTitle from "../components/ui/sectionTitle/sectionSubtitle";
import SectionBlackLabel from "../components/ui/sectionTitle/SectionBlackLabel";
import car from "../assets/images/car.png";
import { useNavigate } from "react-router-dom";
import SelectInput from "../components/ui/input/SelectInput";
import ImageScan from "../components/ui/imagescan/ImageScan";
import { createPolicy } from "../components/JsonToSoapXml/createPolicy";
import SecondaryButton from "../components/ui/button/SecondaryButton";
import {
  comprehensiveInsurance,
  OIAComprehensiveInsurance,
  OIAThirdPartyInsurance,
  thirdPartyInsurance,
} from "../helpers/PlanList";
import { plateCodeList } from "../helpers/plateCodeList";
import { getDLAuth, getRCAuth } from "../AuthService";
import axios from "axios";
import { getQuoteV2 } from "../components/SoapXmlToJson/getQuoteV2";
import { getQuoteV1 } from "../components/SoapXmlToJson/getQuoteV1";
import { toast } from "react-hot-toast";
import { base64ToFile } from "../helpers/base64ToFile";
import { getErrorMessage } from "../helpers/errorMessage";
import { isValidOmanMobile, isValidPlateNumber } from "../helpers/validation";
import { useDispatch, useSelector } from "react-redux";
import ConfirmBox from "../components/modal/ConfirmBox";
import LoadingMask from "../components/loadingMask/LoadingMask";
import { useLocation } from "react-router-dom";
import SectionLargeTitle from "../components/ui/sectionTitle/SectionLargeTitle";
import { getTransDtls } from "../components/JsonToSoapXml/getTransDtls";
import { getTransDtlsSoap } from "../components/SoapXmlToJson/getTransDtlsSoap";
import { getValidAccessToken } from "../services/oauthservice";
import { createApiLog } from "../helpers/apiLogger.js";
import { getTransDtlsSoapV1 } from "../components/SoapXmlToJson/getTransDtlsSoapV1.js";
import { encryptRSA } from "../services/encrypt.js";

const BuyPolicy = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [formData, setFormData] = useState({
    mobileNo: "",
    firstName: "",
    vehicleValue: "",
    plateNo: "",
    plateCode: "",
    plateRegType: "1",
    civilId: "",
    product: "",
    chasisNo: "",
    emailId: "",
    riskType: "",
    srcBusId: "CPW",
  });
  const { product } = formData;
  const [requiredFields, setRequiredFields] = useState([
    "firstName",
    "mobileNo",
    "plateNo",
    "plateCode",
    "plateRegType",
    "civilId",
    "product",
  ]);
  const [showModal, setShowModal] = useState(false);
  const [errMessage, setErrMessage] = useState("");
  const [isPopulatedMulkiya, setIsPopulatedMulkiya] = useState(false);
  const [isPopulatedDriveLicense, setIsPopulatedDriveLicense] = useState(false);
  const [selectedMulkiyaImage, setSelectedMulkiyaImage] = useState();
  const [selectedDrivingLImage, setSelectedDrivingLImage] = useState();
  const [mulkiyaInputType, setMulkiyaInputType] = useState('MANUAL')
  const [drivingInputType, setDrivingInputType] = useState('MANUAL')

  const { partnerDetail } = useSelector((state) => state.domainReducer)
  const { PARTNER_ID, PARTNER_NAME } = partnerDetail
  const { partnerConfig } = useSelector((state) => state.partnerConfig || {});
  const { SHOW_MULTIPLE_PLANS = 1, SRC_BUS_ID = 'CP' } = partnerConfig || {};


  const mulkiyaTabRef = useRef(null);
  const drivingLicenseTabRef = useRef(null);
  const { loading } = useSelector((state) => state.loadingReducer);

  const isFormValid = requiredFields.every(
    (field) => String(formData[field] ?? "").trim() !== ""
  );

  // const isFormValid = requiredFields.every((field) => {
  //   const value = formData[field]?.trim(); // Ensure it's a string

  //   return !!value;
  // });

  const getQuoteApiUrl = SHOW_MULTIPLE_PLANS
    ? `${process.env.REACT_APP_GET_QUOTE_V2}`
    : `${process.env.REACT_APP_GET_QUOTE}`;


  const navigate = useNavigate();
  const incomingData = location.state;
  useEffect(() => {
    if (location.state) {
      const incomingData = location.state;
      setFormData((prev) => ({
        ...prev,
        mobileNo: incomingData.mobileNumber || prev.mobileNo,
        firstName: incomingData.name || prev.firstName,
        transId: incomingData.transId
      }));
    } else {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  useEffect(() => {
    if (product === "0501") {
      setRequiredFields((prevFields) => [...prevFields, "vehicleValue"]);
    } else if (product === "0502") {
      setRequiredFields((prevFields) =>
        prevFields.filter((field) => field !== "vehicleValue")
      );
    }

    if (!SHOW_MULTIPLE_PLANS) {
      setRequiredFields((prevFields) => [...prevFields, "riskType"]);
    }
  }, [product, SHOW_MULTIPLE_PLANS]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelectProduct = (productCode) => {
    setFormData((prevData) => ({
      ...prevData,
      product: productCode,
      vehicleValue: productCode === "0501" ? prevData.vehicleValue : "",
    }));
  };

  const handleSelectPlan = (plan) => {
    setFormData((prevData) => ({
      ...prevData,
      riskType: plan,
    }));
  };

  const changeMulkiyaTab = (index) => {
    if (mulkiyaTabRef.current) {
      mulkiyaTabRef.current.setActiveTab(index);
    }
  };

  const changeDrivingLicenseTab = (index) => {
    if (drivingLicenseTabRef.current) {
      drivingLicenseTabRef.current.setActiveTab(index);
    }
  };

  const handleGetRcOcr = async (images, mulkiyaType) => {
    const { access_token = '' } = await getRCAuth("Dhofar", "x8DFEseX4hVekPVLqMQy") || {};
    setSelectedMulkiyaImage(images);
    const uploadPromise = Promise.all(
      images.map(async (image) => {
        const formData = new FormData();
        formData.append("fileKey", image);

        try {
          const response = await axios.post(
            "https://ocr.dhofarinsurance.com:9950/output_ocr",
            formData,
            {
              headers: {
                Authorization: `Bearer ${access_token}`,
                "Content-Type": "multipart/form-data",
              },
            }
          );
          setIsPopulatedMulkiya(true);
          setMulkiyaInputType(mulkiyaType)
          return response.data;
        } catch (error) {
          if (error.response && error.response.status === 400) {
            throw new Error(
              "Failed to read Mulkiya. Please try again with a clearer image."
            );
          }
          throw new Error("Image upload failed. Please try again.");
        }
      })
    );

    toast.promise(uploadPromise, {
      loading: "Uploading and processing Mulkiya...",
      success: "Mulkiya details extracted successfully!",
      error: (err) => err.message,
    });

    try {
      const responses = await uploadPromise;

      const consolidatedResponse = Object.assign({}, ...responses);

      if (
        !consolidatedResponse.Chassis ||
        !consolidatedResponse.Registration_Number_Eng
      ) {
        throw new Error("Mulkiya data extraction failed. Try again.");
      }

      setFormData((prevData) => ({
        ...prevData,
        plateNo:
          consolidatedResponse.Registration_Number_Eng.split("/")[0].trim(),
        plateCode:
          consolidatedResponse.Registration_Number_Eng.split("/")[1].trim(),
        plateRegType: 1,
      }));

      changeMulkiyaTab(2);
    } catch (error) {
      console.error("OCR process failed:", error);
    }
  };

  const handleGetDrivingLicenseOcr = async (images, drivingInputType) => {
    const { access_token = '' } = await getDLAuth("Dhofar", "x8DFEseX4hVekPVLqMQy");
    setSelectedDrivingLImage(images);
    const uploadPromise = Promise.all(
      images.map(async (image, index) => {
        const formData = new FormData();

        if (typeof image === "string") {
          const file = base64ToFile(image, `scanned_image_${index + 1}.png`);
          formData.append("fileKey", file);
        } else if (image instanceof File) {
          formData.append("fileKey", image);
        }

        try {
          const response = await axios.post(
            "https://ocr.dhofarinsurance.com:9951/output_ocr",
            formData,
            {
              headers: {
                Authorization: `Bearer ${access_token}`,
                "Content-Type": "multipart/form-data",
              },
            }
          );
          setIsPopulatedDriveLicense(true);
          setDrivingInputType(drivingInputType)
          return response.data;
        } catch (error) {
          if (error.response && error.response.status === 400) {
            throw new Error(
              "Failed to read Driving License. Please try again with a clearer image."
            );
          }
          throw new Error("Image upload failed. Please try again.");
        }
      })
    );

    toast.promise(uploadPromise, {
      loading: "Uploading and processing Driving License...",
      success: "Driving License details extracted successfully!",
      error: (err) => err.message,
    });

    try {
      const responses = await uploadPromise;

      const consolidatedResponse = Object.assign({}, ...responses);

      if (!consolidatedResponse.NAME || !consolidatedResponse.LICENSE_NUMBER) {
        throw new Error("Driving License data extraction failed. Try again.");
      }

      setFormData((prevData) => ({
        ...prevData,
        firstName: consolidatedResponse.NAME,
        civilId: consolidatedResponse.LICENSE_NUMBER,
      }));

      changeDrivingLicenseTab(2);
    } catch (error) {
      console.error("OCR process failed:", error);
    }
  };

  const tabsData = [
    {
      title: "Upload",
      content: <FileUpload onFileSelect={handleGetRcOcr} uniqueId="rc-ocr" />,
    },
    {
      title: "Scan",
      content: <ImageScan onUpload={handleGetRcOcr} />,
    },
    {
      title: isPopulatedMulkiya ? "Mulkiya Details" : "Enter Details",
      content: (
        <div className="row">
          <div className="col-md-6">
            <TextInput
              label="Plate Number"
              type="text"
              name="plateNo"
              value={formData.plateNo}
              onChange={handleChange}
              required={true}
              placeholder="Enter your Plate Number"
              disabled={isPopulatedMulkiya}
              requiredMsg="Please enter your Plate Number"
              isAutoPopulated={isPopulatedMulkiya}
            />
          </div>
          <div className="col-md-6">
            <SelectInput
              label="Plate Code"
              name="plateCode"
              value={formData.plateCode}
              onChange={handleChange}
              options={plateCodeList}
              required={true}
              disabled={isPopulatedMulkiya}
              requiredMsg="Please enter your Plate Code"
              isAutoPopulated={isPopulatedMulkiya}
            />
          </div>
          <div className="col-md-6">
            <SelectInput
              label="Plate Type"
              name="plateRegType"
              value={formData.plateRegType}
              onChange={handleChange}
              options={[{ value: "1", label: "Oman" }]}
              required={true}
              disabled={true}
            />
          </div>
          <div className="col-md-6">
            {/* <TextInput
              label="Chassis Number"
              name="chasisNo"
              type="text"
              value={formData.chasisNo}
              onChange={handleChange}
              required={true}
              placeholder="Enter your Chassis Number"
              disabled={isPopulatedMulkiya}
            /> */}
          </div>
        </div>
      ),
    },
  ];

  const drivingLicenseTabsData = [
    {
      title: "Upload",
      content: (
        <FileUpload
          onFileSelect={handleGetDrivingLicenseOcr}
          uniqueId="dl-ocr"
        />
      ),
    },
    {
      title: "Scan",
      content: <ImageScan onUpload={handleGetDrivingLicenseOcr} />,
    },
    {
      title: isPopulatedDriveLicense
        ? "Driving License Details"
        : "Enter Details",
      content: (
        <div className="row">
          <div className="col-md-6">
            <TextInput
              label="Civil ID / License No"
              type="text"
              name="civilId"
              value={formData.civilId}
              onChange={handleChange}
              required={true}
              placeholder="Enter your Civil ID"
              disabled={isPopulatedDriveLicense}
              isAutoPopulated={isPopulatedDriveLicense}
              requiredMsg="Please enter your Civil ID / License No"
            />
          </div>
          <div className="col-md-6"></div>
          <div className="col-md-12">
            <TextInput
              label="Full Name"
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              required={true}
              placeholder="Enter your Full Name"
              disabled={isPopulatedDriveLicense}
              isAutoPopulated={isPopulatedDriveLicense}
              requiredMsg="Please enter your Full Name"
            />
          </div>
        </div>
      ),
    },
  ];

  const validateForm = () => {
    const { isValid = false, errMsg = "" } = isValidOmanMobile(
      formData.mobileNo
    );

    if (!isValid && errMsg !== "") {
      setErrMessage(errMsg);
      setShowModal(true);
      return isValid;
    }
    const { isValidPlateNo = false, errMsgPlateNo = "" } = isValidPlateNumber(
      formData.plateNo
    );
    if (!isValidPlateNo && errMsgPlateNo !== "") {
      setErrMessage(errMsgPlateNo);
      setShowModal(true);
      return isValidPlateNo;
    }

    return true;
  };

  const getActiveQuoteByTrans = async (quoteNo) => {
    const soapRequest = getTransDtls({ quoteNo, txnTyp: 'Q', srcBusId: SRC_BUS_ID })
    try {
      const response = await fetch(`${process.env.REACT_APP_GET_TRANS_DTLS}`, {
        method: "POST",
        headers: {
          "Content-Type": "text/xml",
        },
        body: soapRequest,
      });
      const responseText = await response.text();

      await createApiLog({
        PARTNER_ID: PARTNER_ID,
        APP_ID: 1,
        COB: "MOTOR",
        TRANS_ID: formData?.transId,
        API: process.env.REACT_APP_GET_TRANS_DTLS,
        REQUEST: soapRequest,
        REQUEST_STATUS: "SUCCESS",
        RESPONSE: responseText,
      })

      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(responseText, "text/xml");
      const extractedData = SHOW_MULTIPLE_PLANS ? getTransDtlsSoap(xmlDoc) : getTransDtlsSoapV1(xmlDoc)

      if (extractedData.quoteStatus === "Quote") {
        const updatedData = { ...extractedData, _ID: incomingData?.userId }
        const updateTransResult = await updateTransDetail(extractedData.quoteNo, 'QUOTE_GENERATED')
        navigate("/get-quote", { state: { ...updatedData, transId: formData?.transId } });
        dispatch({ type: "LOADING", payload: false });
      } else {
        dispatch({ type: "LOADING", payload: false });
        setErrMessage("Quote status not valid");
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error:", error);
      dispatch({ type: "LOADING", payload: false });

      await createApiLog({
        PARTNER_ID: PARTNER_ID,
        APP_ID: 1,
        COB: "MOTOR",
        TRANS_ID: formData?.transId,
        API: process.env.REACT_APP_GET_TRANS_DTLS,
        REQUEST: soapRequest,
        REQUEST_STATUS: "Error",
        RESPONSE: error,
      })
    }
  }

  const checkPreviousInsurer = async () => {
    const soapRequest = getTransDtls({ ...formData, plateNumber: formData.plateNo, txnTyp: 'P', srcBusId: SRC_BUS_ID })
    try {
      const response = await fetch(`${process.env.REACT_APP_GET_TRANS_DTLS}`, {
        method: "POST",
        headers: {
          "Content-Type": "text/xml",
        },
        body: soapRequest,
      });
      const responseText = await response.text();

      await createApiLog({
        PARTNER_ID: PARTNER_ID,
        APP_ID: 1,
        COB: "MOTOR",
        TRANS_ID: formData?.transId,
        API: process.env.REACT_APP_GET_TRANS_DTLS,
        REQUEST: soapRequest,
        REQUEST_STATUS: "SUCCESS",
        RESPONSE: responseText,
      })

      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(responseText, "text/xml");

      const previousInsurer = xmlDoc.getElementsByTagName("previousInsurer")[0]?.textContent || ""
      
      if (previousInsurer === 'DHOFAR INSURANCE COMPANY S.O.A.G.') {
        setErrMessage("As you are our existing customer, kindly use renew policy option to renew your policy");
        setShowModal(true);
        dispatch({ type: "LOADING", payload: false });
        return true
      }

      return false
    } catch (error) {
      console.error("Error:", error);
      dispatch({ type: "LOADING", payload: false });

      await createApiLog({
        PARTNER_ID: PARTNER_ID,
        APP_ID: 1,
        COB: "MOTOR",
        TRANS_ID: formData?.transId,
        API: process.env.REACT_APP_GET_TRANS_DTLS,
        REQUEST: soapRequest,
        REQUEST_STATUS: "Error",
        RESPONSE: error,
      })
    }
  }

  const updateTransDetail = async (quoteNo, journeyStatus) => {
    const formDataUpdate = new FormData();

    const requestPayload = {
      transId: formData.transId,
      mulkiyaInputType,
      plateNumber: formData.plateNo,
      plateCode: formData.plateCode,
      plateType: "Oman",
      dlInputType: drivingInputType,
      licenseNo: formData.civilId,
      fullName: formData.firstName,
      selectedProduct:
        formData.product === "0501"
          ? "Comprehensive Insurance"
          : "Third Party Insurance",
      vehicleValue: formData.vehicleValue,
      quoteNo,
      leadStatus: "CONVERTED_TO_QUOTE",
      journeyStatus
    };

    const encrypted = await encryptRSA(requestPayload);
    formDataUpdate.append("encrypted", JSON.stringify(encrypted));

    if (selectedMulkiyaImage?.[0]) {
      formDataUpdate.append("mulkiyaImageFront", selectedMulkiyaImage[0]);
    }
    if (selectedMulkiyaImage?.[1]) {
      formDataUpdate.append("mulkiyaImageBack", selectedMulkiyaImage[1]);
    }

    if (selectedDrivingLImage?.[0]) {
      formDataUpdate.append("dlImageFront", selectedDrivingLImage[0]);
    }
    if (selectedDrivingLImage?.[1]) {
      formDataUpdate.append("dlImageBack", selectedDrivingLImage[1]);
    }

    try {
      const token = await getValidAccessToken();

      const response = await axios.put(
        `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/leads`,
        formDataUpdate,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      await createApiLog({
        PARTNER_ID,
        APP_ID: 1,
        COB: "MOTOR",
        TRANS_ID: formData.transId,
        API: `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/leads`,
        REQUEST: requestPayload,
        REQUEST_STATUS: "SUCCESS",
        RESPONSE: response?.data ?? response,
      });
    } catch (error) {
      console.error("API Error:", error.response?.data || error.message);

      await createApiLog({
        PARTNER_ID,
        APP_ID: 1,
        COB: "MOTOR",
        TRANS_ID: formData.transId,
        API: `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/leads`,
        REQUEST: requestPayload,
        REQUEST_STATUS: "FAILED",
        RESPONSE: error.response?.data ?? error,
      });
    }
  };


  const handleClick = async () => {
    dispatch({ type: "LOADING", payload: true });
    if (!validateForm()) {
      console.log("error on validation");
      dispatch({ type: "LOADING", payload: false });
      return;
    }

    const checkPreviousPolicy = await checkPreviousInsurer()
    
    if (checkPreviousPolicy) {
      return
    }
    
    const soapRequest = createPolicy({ ...formData, srcBusId: SRC_BUS_ID });
    try {
      const response = await fetch(getQuoteApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "text/xml",
        },
        body: soapRequest,
      });

      const responseText = await response.text();
      const logData = {
        PARTNER_ID: PARTNER_ID,
        APP_ID: 1,
        COB: "MOTOR",
        TRANS_ID: formData?.transId,
        API: getQuoteApiUrl,
        REQUEST: soapRequest,
        REQUEST_STATUS: "SUCCESS",
        RESPONSE: responseText,
      }
      await createApiLog(logData)

      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(responseText, "text/xml");
      const extractedData = SHOW_MULTIPLE_PLANS
        ? getQuoteV2(xmlDoc)
        : getQuoteV1(xmlDoc);

      if (extractedData.error && extractedData.error.includes("Active quote")) {
        const errorMessage = extractedData.error;
        const regex = /\d{3}\/\d{4}\/\d{4}\/[PQ]\/\d{6}(?:\/R\d{2})?/;
        const match = errorMessage.match(regex);

        if (match && match[0]) {
          const quoteNumber = match[0]; // "104/0502/2025/Q/000509"
            getActiveQuoteByTrans(quoteNumber)
          }
      } else {
        if (extractedData.error) {
          console.error("Error:", extractedData.error);
          const errMsg = getErrorMessage(extractedData.error);
          dispatch({ type: "LOADING", payload: false });
          setErrMessage(extractedData.error);
          setShowModal(true);
        } else {

          if (extractedData.quoteStatus === "Quote") {
            const updateTransResult = await updateTransDetail(extractedData.quoteNo, 'QUOTE_GENERATED')
          const updatedData = { ...extractedData, _ID: incomingData?.userId }
          navigate("/get-quote", { state: { ...updatedData, transId: formData?.transId } });
          dispatch({ type: "LOADING", payload: false });
        } else {
          dispatch({ type: "LOADING", payload: false });
          setErrMessage("Quote status not valid");
          setShowModal(true);
        }
      }
      }

    } catch (error) {

      await createApiLog({
        PARTNER_ID: PARTNER_ID,
        APP_ID: 1,
        COB: "MOTOR",
        TRANS_ID: formData?.transId,
        API: getQuoteApiUrl,
        REQUEST: soapRequest,
        REQUEST_STATUS: "Error",
        RESPONSE: error,
      })
      
      console.error("Error:", error);
      dispatch({ type: "LOADING", payload: false });
    }
  };

  const handleCloseConfirm = () => {
    setErrMessage("");
    setShowModal(false);
  };

  const isOIA = PARTNER_NAME === "OIA";
  const comprehensiveList = isOIA ? OIAComprehensiveInsurance : comprehensiveInsurance;
  const thirdPartyList = isOIA ? OIAThirdPartyInsurance : thirdPartyInsurance;

  return (
    <>
      <ConfirmBox
        show={showModal}
        // title="Confirm Logout"
        message={errMessage}
        onCancel={handleCloseConfirm}
      />
      {loading && <LoadingMask />}
      <div className="container">
        {/* Section Header */}
        <div className="row mb-1">
          <div className="col-md-12">
            <SectionHeader title="Motor Insurance " stepNo={1} totalStep={3} />
          </div>
        </div>
        {partnerDetail?.LOGO && (
          <div className="container bg-white">
            <div className="row mt-2 mb-1">
              <div className="col-md-12 mt-2 mb-2 d-flex justify-content-center">
                <img
                  src={partnerDetail?.LOGO}
                  style={{ height: "65px" }}
                  alt="partnerlogo"
                />
              </div>
            </div>
          </div>
        )}
        <div className="container bg-white">
          <div className="row mt-2">
            <div className="col-md-12 mt-3">
              <SectionLargeTitle title="Buy Policy" />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-6">
                  <TextInput
                    label="Mobile Number"
                    type="tel"
                    name="mobileNo"
                    value={formData.mobileNo}
                    onChange={handleChange}
                    placeholder="Enter your mobile number"
                    required={true}
                    requiredMsg="Please enter your Mobile Number"
                    disabled={true}
                  />
                </div>
                <div className="col-md-6"></div>
              </div>
              <SectionSubTitle title="Mulkiya" />
              <TabComp tabs={tabsData} ref={mulkiyaTabRef}  />
              <SectionSubTitle title="Driving License" className="mt-3"/>
              <TabComp
                tabs={drivingLicenseTabsData}
                ref={drivingLicenseTabRef}
              />
              <SectionBlackLabel title="Select Product" />
              <div className="row mb-4 mt-3">
                <div className="col-md-6 mb-3">
                  <SecondaryButton
                    label="Comprehensive Insurance"
                    onClick={() => handleSelectProduct("0501")}
                    isActive={formData.product === "0501"}
                  />
                </div>
                <div className="col-md-6">
                  <SecondaryButton
                    label="Third Party Insurance"
                    onClick={() => handleSelectProduct("0502")}
                    isActive={formData.product === "0502"}
                  />
                </div>
              </div>
              {formData.product === "0501" ? (
                <TextInput
                  label="Vehicle Value (Sum Assured)"
                  // type="tel"
                  name="vehicleValue"
                  value={formData.vehicleValue}
                  onChange={handleChange}
                  placeholder="Type here"
                />
              ) : (
                ""
              )}
              {/* <label htmlFor='select plan' className="form-label">
              Select Plan
            </label> */}
              {formData.product && !SHOW_MULTIPLE_PLANS ? (
                <>
                  <SectionBlackLabel title="Select Plan" />
                  <div className="d-grid gap-3 mb-3">
                    {(formData.product === "0501"
                      ? comprehensiveList
                      : formData.product === "0502"
                        ? thirdPartyList
                      : []
                    ).map((plan, index) => (
                      <PlanButton
                        key={index}
                        text={plan.planName}
                        infoText="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam"
                        onClick={() => handleSelectPlan(plan.planId)}
                        isActive={formData.riskType === plan.planId}
                      />
                    ))}
                  </div>
                </>
              ) : null}

              <PrimaryButton
                label="Get Quote"
                onClick={handleClick}
                disabled={!isFormValid}
              />
            </div>
            <div className="col-md-6">
              <img src={car} className="img-fluid w-auto" alt="car" />
            </div>
          </div>

          {/* Text Inputs */}
          <div className="row mb-4">
            <div className="col-md-6"></div>
            <div className="col-md-6"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BuyPolicy;
